 <div style="margin-left: 80%; margin-bottom: 2%;">
        <button   id="print-button"  class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
        printSectionId="print-section"  [useExistingCss]="true"  ngxPrint>
      Print
      </button>

      <button (click)="printPage()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
    Print
    </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Advt_Invoice_Register')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>  


<ng-container *ngIf="reportType == 'In Detail'">
        <div class="container" id="print-section"style="margin-top:50px; margin-right: 3px; margin-left: 3px;">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th colspan="13" style="font-size: medium;">हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग - Advt Invoice
                            Register
                        </th>
                        <th colspan="2" style="font-size: medium;" >In Detail</th>
                        <th colspan="5" style="font-size: medium;">दिनांक - {{ today | date:"dd-MM-yyy" }}</th>
                        <th colspan="3" style="font-size: medium;">पृष्ठ क्र.- 1</th>
                    </tr>
                    <tr>
                        <!-- <th></th> -->
                        <th colspan="8" class="leftAlign">
                            <!-- <div>Issue Name : {{ issueName }}</div> -->
                        </th>
                        <th colspan="6" class="leftAlign">
                            <div>Issue Date :</div>
                        </th>
                        <th colspan="9" class="leftAlign" style="font-size: medium;">
                            <div>Date : From : {{ startDate | date:"dd-MM-yyy" }} To : {{ endDate | date:"dd-MM-yyy" }}
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Invoice No.</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Invoice<br>Date</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Advertiser  Name</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Customer <br>  Name</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue  Name</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue Date</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Representative <br> Name</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Office <br> Representative <br> Name</th>
                        <th colspan="5" style="font-size: 14px !important; text-align: center;">Weekly Issue <br> Date</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Advt. <br> Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Discount  <br>Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Amount<br>before GST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">CGST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">SGST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">IGST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Total GST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Total Invoice <br> Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Paid <br> Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Unpaid<br>Amount</th>
                    </tr>
                    <tr>
                        <th>1st Week</th>
                        <th>2nd Week</th>
                        <th>3rd Week</th>
                        <th>4th Week</th>
                        <th>5th Week</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of filteredAdvtInvoiceData; ">
                        <ng-container *ngIf="!end">
                            <ng-container>
                                <tr>
                                    <td style="text-align: start;">{{ data['invoice_no'] }}</td>
                                    <td style="text-align: start;">{{ data['invoice_date'] }}</td>
                                    <td style="text-align: start;font-weight:bold">{{ data['advt_name']|slice:0:30 }}</td>
                                    <td style="text-align: start;">{{ data['cust_name'] }}</td>
                                    <td style="text-align: start;">{{ data['combined_issue_name'] }}</td>
                                    <td style="text-align: start;"> {{ data['combined_issue_date'] }}</td>
                                    <td style="text-align: start;">{{ data['rep_name'] }}</td>
                                    <td style="text-align: start;">{{ data['off_rep_name'] }}</td>

                                    <!-- <td>{{ data['firstweek_issue_date'] }}</td> -->
                                    <td style="text-align: end;"><ng-container *ngIf="data['first_week'] != '0'; else week1">{{  data['first_week_amount'] }}</ng-container>
                                        <ng-template #week1>0</ng-template></td>
                                    <td style="text-align: end;"><ng-container *ngIf="data['second_week'] != '0'; else week2">{{  data['second_week_amount']  }} </ng-container>
                                            <ng-template #week2>0</ng-template></td>
                                    <td style="text-align: end;"><ng-container *ngIf="data['third_week'] != '0'; else week3">{{  data.third_week_amount }}</ng-container>
                                                <ng-template #week3>0</ng-template></td>
                                    <td style="text-align: end;"><ng-container *ngIf="data['fourth_week'] != '0'; else week4">{{  data['fourth_week_amount'] }}</ng-container>
                                                    <ng-template #week4>0</ng-template></td>
                                    <td style="text-align: end;"><ng-container *ngIf="data['fifth_week'] != '0'; else week5">{{  data['fifth_week_amount'] }} </ng-container>
                                                        <ng-template #week5>0</ng-template></td>
                                        
                                    <!-- <td>{{ data['secondweek_issue_date'] }}</td>
                                    <td>{{ data['thirdweek_issue_date'] }}</td>
                                    <td>{{ data['fourthweek_issue_date'] }}</td>
                                    <td>{{ data['fifthweek_issue_date'] }}</td> -->
                                    <td style="text-align: end;"><span>{{ data['advt_amt'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['discount'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['beforegst_amt'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['cgst'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['sgst'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['igst'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['gst'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['invoice_total'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['received_amt'] }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['unpaid_amount'] }}</span></td>


                                </tr>
                                <!-- <tr *ngIf="end1">
                                    <td colspan="8" class="boldText">
                                        <p>महिन्यांची एकूण : {{ data['issue_date'] | date:"MMM" }}</p>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="right">
                                        <p><span>
                                                {{ data['totalAdvtAmt'] }}
                                            </span></p>
                                    </td>
                                    <td class="right">
                                        <p><span>{{ data['totalDisAmt'] }}</span></p>
                                    </td>
                                    <td class="right">
                                        <p><span>{{ data['totalNetAmt'] }}</span></p>
                                    </td>
                                    <td class="right">
                                        <p><span>{{ data['totalCGST'] + data['totalSGST'] }}</span></p>
                                    </td>
                                    <td class="right">
                                        <p><span>{{ data['totalInvoiceAmount'] }}</span></p>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr> -->
                            </ng-container>
                        </ng-container>
                        <!-- <ng-container *ngIf="end">
                            <tr>
                                <td colspan="8" class="boldText">
                                    <p>एकूण</p>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="right">
                                    <p><span>{{ item['totalAdvtAmt1'] }}</span></p>
                                </td>
                                <td class="right">
                                    <p><span>{{ item['totalDisAmt1'] }}</span></p>
                                </td>
                                <td class="right">
                                    <p><span>{{ item['totalNetAmt1'] }}</span></p>
                                </td>
                                <td class="right">
                                    <p><span>{{ item['totalCGST1'] + item['totalSGST1'] }}</span></p>
                                </td>
                                <td class="right">
                                    <p><span>{{ item['totalInvoiceAmount1'] }}</span></p>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </ng-container> -->
                    </ng-container>
                </tbody>
              
                 <td style="font-weight: bold;  border-bottom: 1px solid #000; border-right: 1px solid #000; border-left: 1px solid #000;" colspan="13">Total</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{advtamount}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;">{{discountamt}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{totalbeforegstamount}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{cgst}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{sgst}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{igst}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;">{{gstcst}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{invoice_total}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;" >{{paidamount}}</td>
                    <td style="text-align: end; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000;">{{invoice_total - paidamount  }}</td>
            </table>
        </div>
    </ng-container>